import { createSlice } from '@reduxjs/toolkit'
import { get } from 'lodash';

const initialQuestionState = {
  question_english: '',
  question_hindi: '',
  predic_start_time: null,
  predic_end_time: null,
  admin_commission: 10,
  slots_per_user: undefined,
  status:0,
  // rate_id1:5,
  // rate_id2:5,
};

export const opinionTradingSlice = createSlice({
  name: 'opinionTrading',
  initialState: {
    question: [],
    modal_show: false,
    questionStates: initialQuestionState,
    isSubjective: false,
    isEdit:false,
    isAdd:false,
  },
  reducers: {
    stateRefresh: (state, action) => {
      state.questionStates = initialQuestionState
      state.isEdit =false
      state.isAdd=true
    },
    stateValues: (state, action) => {
      state.questionStates[action.payload.name] = action.payload.value
    },
    setEditQuestion: (state, action) => {
      state.questionStates = action.payload
      state.isEdit=action.payload.isEdit
    },
    setStatus: (state, action) => {
      state.questionStates.status = action.payload.status
    },
    setAmountState:(state,action) =>{
      state.questionStates.rate_id1 =  action.payload.value
      state.questionStates.rate_id2 = 10 - Number(action.payload.value)
    }
  }
})

// Action creators are generated for each case reducer function
export const { addQuestion, stateRefresh, stateValues, setEditQuestion,setStatus,setAmountState } = opinionTradingSlice.actions

export default opinionTradingSlice.reducer